import { useLayoutEffect, useRef, useState } from 'react';

export const useDetectSticky = () => {
  const [isSticky, setIsSticky] = useState(false);
  const ref = useRef<Element | null>(null);

  useLayoutEffect(() => {
    const cashRrf = ref;
    const observer = new IntersectionObserver(
      ([e]) => setIsSticky(e.intersectionRatio < 1),
      { threshold: [1] }
    );
    if (cashRrf?.current) {
      observer.observe(cashRrf.current);
    }

    return () => {
      if (cashRrf?.current) {
        observer.unobserve(cashRrf.current);
      }
    };
  }, [ref]);

  return [isSticky, ref, setIsSticky];
};
